<template>
    <div>

        <div class="form-group mt-2" >
            <label class="form-label">
                {{__t('USE_BOTS')}}
            </label>

            <div class="input-group flex-nowrap">
                <b-form-radio-group
                    id="btn-radios-1"
                    v-model="use_bot"
                    button-variant="outline-primary"
                    :options="[
                                      { text: __t('YES'), value: true },
                                      { text:  __t('NO'), value: false }
                            ]"
                    name="radios-btn-default"
                    buttons
                >
                </b-form-radio-group>
            </div>
        </div>


        <div class="bots">
            <div class="form-group mt-2" v-if="use_bot">
                <label class="form-label" for="advanced_price">
                    {{__t('BOTS')}}
                </label>
                <div class="input-group flex-nowrap">
                    <v-select multiple v-model="bot_ids"
                              class="imc_reasons w-50"
                              label="title_bot"
                              :reduce="bot => bot.id"
                              :filterable="false"
                              :options=bots
                    >

                        <template slot="option" slot-scope="option">
                            <div class="d-center">
                                {{ option.channel_data.username }}
                                <small >{{option.channel}}</small>
                            </div>
                        </template>
                    </v-select>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

import vSelect from 'vue-select'
export default {
    name: "sendpulse_bot_tab",
    props : {
        location : {
            type : Object
        }
    },

    data() {
        return {
            bots: [],
        }
    },
    components: {
        vSelect
    },
    mounted() {
        this.load_bots();
    },

    methods : {
        async load_bots() {
            let self = this;
            self.bots = [];

            await agr_api.get('aggregators/sendpulse/bots/').then(({data}) => {
                if (data.status === "operation_success") {
                    self.bots = data.data;
                }
            }).catch(({response}) => {
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },
    },

    computed : {
        use_bot : {
            get() {``
                return this.location.bot_settings.use_bot;
            },
            set(val) {
                this.location.bot_settings.use_bot = val;
            }
        },

        bot_ids : {
            get() {
                return this.location.bot_settings.bots_ids;
            },
            set(val) {
                this.location.bot_settings.bots_ids = val;
            }
        },

        general_fields() {

            if(this.location.hasOwnProperty("bot_settings")) {
                let res = [];
                for (const [key, value] of Object.entries(this.location.bot_settings)) {
                    if(key != 'id') {
                        res.push({
                            key: key,
                            value: value,
                            title: this.__t(key.toUpperCase())
                        });
                    }
                }

                return res;
            }
            return [];
        },
    }
}
</script>

<style scoped>

</style>
